// LICENSE_CODE ZON
'use strict';

/*jslint browser:true, es6:true, node:true, react:true*/
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useContext } from 'react';
import cn from 'classnames';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { App_context } from '../../context.js';
import { User_nav } from './user_nav.js';
import { Menu_nav } from './menu_nav.js';
var Navbar_menu = props => {
  useTranslation();
  var _useContext = useContext(App_context),
    has_ext = _useContext.has_ext,
    user = _useContext.user,
    is_client = _useContext.is_client;
  var _props$route_opt = props.route_opt,
    _props$route_opt2 = _props$route_opt === void 0 ? {} : _props$route_opt,
    user_links = _props$route_opt2.user_links,
    hide_header = props.hide_header,
    toggled = props.toggled,
    set_toggled = props.set_toggled;
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname;
  var user_or_ext = (has_ext || user) && pathname != '/download_hola';
  var show_menu = !hide_header && user_or_ext && !user_links;
  var show_separator = is_client && show_menu;
  var collapse_cls = cn('navbar-collapse', toggled && 'active');
  return /*#__PURE__*/React.createElement("div", {
    className: collapse_cls
  }, show_menu && /*#__PURE__*/React.createElement(Menu_nav, props), show_separator && /*#__PURE__*/React.createElement("div", {
    className: "separator"
  }), is_client && /*#__PURE__*/React.createElement(User_nav, _extends({}, props, {
    set_toggled: set_toggled,
    user_links: user_links
  })));
};
export { Navbar_menu };